import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../pages/css/LeadDatabase.css";
import banner from '../images/Hrias-b2b-banner.png';
import verified90 from '../images/Hrias-multi-2.png';
import filtersb2b from '../images/Hrias-multi-3.png'
import intentSignal from '../images/Hrias-multi-4.png';
import intentSignal2 from '../images/Hrias-Intent_Signal.png';
import outreach from '../images/Hrias-multi-5.png'
import b2bcrm from '../images/Hrias-multi-6.png';
import customDev from '../images/Hrias-Custom_Development.png';
import cTOne from '../images/kpmg.png';
import cTTwo from '../images/deloite.png';
import cTThree from '../images/berkshire.png';
import cTFive from '../images/pwc.jpg';
import cTSix from '../images/microsoft.png';
import cTFour from '../images/Google.png';
import dashImg from '../images/Hrias-multi-dash.png';
import { useNavigate } from "react-router-dom";

function MultiChannelSequence() {
  const navigate = useNavigate();
  return (
    <div className="b2b-lead-page">
      {/* Hero Section */}
      <section
        className="hero-section text-center text-white d-flex align-items-center justify-content-center"
        style={{
          backgroundImage:
            `url(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          height: "40vh",
        }}
      >
        <div className="container" style={{ color: "#ffffff" }}>
          <h1 className="fw-bold" style={{ color: "#275a8eff" }}>
            Email, LinkedIn, or phone?   <span className="highlight" style={{ color: "#7102c1ff" }}>Meet your leads wherever</span> they are From 1 dashboard.
          </h1>
          <p className="lead mt-3" style={{ color: "#890059ff" }}>
            Every customer journey is different. With Hrias, connect across multiple channels, on autopilot from one synced campaign.
          </p>
          <button
            className="btn btn-primary mt-4"
            style={{
              backgroundColor: "#134373ff",
              border: "none",
              color: "#ffffffff",
              fontWeight: "600",
              borderRadius: "30px",
              padding: "12px 30px",
              transition: "all 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#5197dcff")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#134373ff")}
            onClick={() => navigate("/contact-us-hrias")}
          >
            Contact Sales
          </button>
        </div>

      </section>
      <section>
        <div className="container py-5">
          <img
            src={dashImg}
            alt="Padded Container"
            className="img-fluid rounded shadow-lg" style={{ width: '100%', height: '960px' }}
          />
        </div>
      </section>
      <section className="container my-5 partner-section">
        {/* Heading */}
        <h5 className="text-center partner-heading">
          Trusted by <span style={{ color: '#fd7e14' }}>6000+</span> Industry Leaders
        </h5>

        {/* Logo Row */}
        <div className="d-flex justify-content-center align-items-center flex-wrap gap-4 mt-4">
          <img src={cTOne} alt="KPMG" className="partner-logo" style={{ width: '120px', height: 'auto' }} />
          <img src={cTTwo} alt="Deloitte" className="partner-logo" style={{ width: '130px', height: 'auto' }} />
          <img src={cTThree} alt="Berkshire" className="partner-logo" />
          <img src={cTFour} alt="Google" className="partner-logo" />
          <img src={cTFive} alt="PwC" className="partner-logo" />
          <img src={cTSix} alt="Microsoft" className="partner-logo" />
        </div>
      </section>


      {/* Section 1 — Verified B2B Contacts */}
      <section className="feature-section py-5 bg-light">
        <div className="container d-flex flex-column flex-md-row align-items-center">
          <div className="col-md-6 mb-4 mb-md-0 text-md-start">
            <h3 className="feature-title">Launch Multichannel Sequences Across Email, LinkedIn & WhatsApp</h3>
            <p className="feature-text">
              HRIAS lets you automate personalized outreach across multiple platforms — send verified emails, connect on LinkedIn, and follow up on WhatsApp — all in one seamless workflow to boost engagement and conversions.
            </p>
            <button className="btn btn-outline-primary" onClick={() => navigate("/contact-us-hrias")}>Explore Leads</button>
          </div>
          <div className="col-md-6 text-center">
            <img
              src={verified90}
              alt="Verified Leads"
              className="img-fluid rounded shadow-sm"
            />
          </div>
        </div>
      </section>

      {/* Section 2 — Smart Filters & Advanced Search */}
      <section className="feature-section py-5">
        <div className="container d-flex flex-column flex-md-row-reverse align-items-center">
          <div className="col-md-6 mb-4 mb-md-0 text-md-start" style={{ marginLeft: '20px' }}>
            <h3 className="feature-title">Email not enough? Automatically connect with leads on LinkedIn and WhatsApp using HRIAS</h3>
            <p className="feature-text">
              Engage prospects across channels — send LinkedIn connection requests, profile visits, messages, and WhatsApp follow-ups — all from a single multichannel sequence.
              Use the HRIAS Chrome Extension to find, enrich, and instantly import verified leads into your campaigns within seconds!
            </p>
            <button className="btn btn-outline-primary" onClick={() => navigate("/contact-us-hrias")}>See Filters</button>
          </div>
          <div className="col-md-6 text-center" >
            <img
              src={filtersb2b}
              alt="Smart Filters"
              className="img-fluid rounded shadow-sm"
            />
          </div>
        </div>
      </section>

      {/* Section 3 — Real-Time Intent Signals */}
      <section className="feature-section py-5 bg-light">
        <div className="container d-flex flex-column flex-md-row align-items-center">
          <div className="col-md-6 mb-4 mb-md-0 text-md-start">
            <h3 className="feature-title">Boost Your Sales Pipeline — Call Warm Leads Instantly with HRIAS</h3>
            <p className="feature-text">
              Discover verified business phone numbers using HRIAS Phone Finder, reach out to leads who’ve already engaged, and close deals faster.
              Get call reminders, dial directly through HRIAS native calling or integrated tools like Aircall and Ringover, and keep every conversation automatically tracked, summarized, and shareable for better team collaboration and conversions.
            </p>
            <button className="btn btn-outline-primary" onClick={() => navigate("/contact-us-hrias")}>View Insights</button>
          </div>
          <div className="col-md-6 text-center">
            <img
              src={intentSignal}
              alt="Intent Signals"
              className="img-fluid rounded shadow-sm"
            />
          </div>
        </div>
      </section>

      {/* Section 4 — Automated Multi-Channel Outreach */}
      <section className="feature-section py-5">
        <div className="container d-flex flex-column flex-md-row-reverse align-items-center">
          <div className="col-md-6 mb-4 mb-md-0 text-md-start" style={{ marginLeft: '20px' }}>
            <h3 className="feature-title">Turn Silent Leads into Clients with WhatsApp Follow-Ups via HRIAS</h3>
            <p className="feature-text">
              Add WhatsApp touchpoints to your HRIAS multichannel sequence to confirm meetings, follow up after demos, or re-engage cold leads effortlessly.
              Send personalized, automated messages at scale — with built-in warm-up and compliance features to keep your sender reputation and number safe.
            </p>
            <button className="btn btn-outline-primary" onClick={() => navigate("/contact-us-hrias")}>Automate Now</button>
          </div>
          <div className="col-md-6 text-center">
            <img
              src={outreach}
              alt="Outreach Automation"
              className="img-fluid rounded shadow-sm"
            />
          </div>
        </div>
      </section>

      {/* Section 5 — CRM & Integrations */}
      <section className="feature-section py-5 bg-light">
        <div className="container d-flex flex-column flex-md-row align-items-center">
          <div className="col-md-6 mb-4 mb-md-0 text-md-start">
            <h3 className="feature-title">Give Conversions a Final Boost with Smart Manual Actions</h3>
            <p className="feature-text">
              Some touches are best done by hand — like leaving a genuine comment on a lead’s LinkedIn post or sending a personalized message.
              HRIAS lets you schedule and automate reminders for manual actions, ensuring your outreach stays personal, authentic, and impactful at every stage of the sales journey.
            </p>
            <button className="btn btn-outline-primary" onClick={() => navigate("/contact-us-hrias")}>View Dashboard</button>
          </div>
          <div className="col-md-6 text-center">
            <img
              src={b2bcrm}
              alt="CRM Integration"
              className="img-fluid rounded shadow-sm"
            />
          </div>
        </div>
      </section>

      <div className="info-box d-flex flex-column flex-md-row align-items-center mb-5">
        <div className="info-img col-md-6 p-3">
          <img
            src={intentSignal2}
            alt="Intent Signals"
            className="img-fluid rounded bg-white p-3 shadow-sm"
          />
        </div>

        <div className="info-content col-md-6 p-4 text-md-start">
          <h4 className="fw-bold mb-3">Powered by Hrias Intent Signals</h4>
          <p className="text-muted fw-semibold mb-3" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}>
            Hrias helps you make data-driven decisions by detecting live buying intent. Get real-time updates whenever your
            target companies post new jobs, publish press releases, launch products, or get featured in the news.
          </p>
          <p className="text-muted fw-semibold mb-4" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}>
            Access detailed company insights including size, employee count, tech stack, revenue, and location — all in one
            dashboard. With Hrias, you always know which prospects are most likely to convert, and when to engage.
          </p>
          <button className="btn btn-primary px-4 py-2" onClick={() => navigate("/contact-us-hrias")} >Contact Sales</button>
        </div>
      </div>

      {/* Section 6 — Custom Development & Add-ons */}
      <section className="feature-section py-5">
        <div className="container d-flex flex-column flex-md-row-reverse align-items-center">
          <div className="col-md-6 mb-4 mb-md-0 text-md-start" style={{ marginLeft: '20px' }}>
            <h3 className="feature-title">Custom Development for Your Needs</h3>
            <p className="feature-text">
              Need extra functionality? HRIAS can develop custom modules like
              AI-enhanced filters, call tracking dashboards, or lead scoring
              algorithms tailored to your business.
            </p>
            <button className="btn btn-outline-primary" onClick={() => navigate("/contact-us-hrias")}>Request Customization</button>
          </div>
          <div className="col-md-6 text-center">
            <img
              src={customDev}
              alt="Custom Development"
              className="img-fluid rounded shadow-sm"
            />
          </div>
        </div>
      </section>

      <section className="container my-5 client-review-section">
        <div className="row align-items-center">
          {/* Left side - client image */}
          <div className="col-12 col-md-3 text-center">
            <img
              src="https://img.freepik.com/free-photo/front-view-sign-language-concept_23-2148572467.jpg" // replace with your client's photo
              alt="Client"
              className="client-img"
            />
          </div>

          {/* Right side - review text */}
          <div className="col-12 col-md-9">
            <p className="client-review">
              “HRIAS Multichannel Sequences completely transformed how our sales and marketing teams connect with prospects across multiple channels.
              The personalized automation feels authentic and efficient, helping us engage decision-makers faster and more effectively.
              Our outreach workflow is smoother than ever, and conversion rates have skyrocketed!”
            </p>
            <h3 className="client-name">Emily Carter</h3>
            <p className="client-position">Sales Director, ApexBridge Solutions</p>

          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section text-center py-5">
        <div className="container">
          <h2 className="cta-title fw-bold mb-3 text-white">
            Start Building Your Multichannel Sequence With Confidence
          </h2>
          <p className="cta-subtitle mt-3 mb-4">
            Get verified leads, real-time insights, and AI-powered automation
            with HRIAS — the smarter way to grow your sales.
          </p>
          <button className="btn btn-primary px-4 py-2" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
        </div>
      </section>
    </div>
  );
}

export default MultiChannelSequence;
